import { defineComponent as _defineComponent } from 'vue'
import i18n from '@/plugins/i18n';
import localized from '@/plugins/vue-localized-formatter/src/localized';
import ContactMessageDialog from '@/components/views/reservation/ContactMessageDialog.vue';

import NewModalDialog from '@/components/dialogs/NewModalDialog.vue';
import { ref, PropType, computed, onMounted } from 'vue';
import Feedback from '@/grpc-api/model/feedback';

import FeedbackRatingChip from '@/components/views/feedback/FeedbackRatingChip.vue';
import { tryEditReservation } from '@/services/reservation-edit-utils';
import router from '@/router';
import { performDispatchAction } from '@/services/vue-utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'FeedbackDetailsDialog',
  props: {
  feedback: { type: Object as PropType<Feedback>, required: true },
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props;

/* eslint-disable object-curly-newline */




const reservation = computed(() => props.feedback.reservation);

const messageDialog = ref(false);

const formatRepliedOnDate = (d: Date) => i18n.t('label.reply_sent_on_x', [localized.dateText(d)!]);

const close = () => emit('close');

const showReservation = async () => {
  const { reservationId } = props.feedback;
  const changeToDate = props.feedback.reservationDtBegin;
  if (reservationId && changeToDate) tryEditReservation(router, reservationId, {}, { changeToDate });
  close();
};

const closeMessageDialog = async (res: boolean | undefined) => {
  if (res && props.feedback) {
    await performDispatchAction('getFeedback', { id: props.feedback.id }) as Feedback | undefined;
  }

  messageDialog.value = false;
};


return { __sfc: true,emit, props, reservation, messageDialog, formatRepliedOnDate, close, showReservation, closeMessageDialog, ContactMessageDialog, NewModalDialog, FeedbackRatingChip }
}

})